import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CustomerProfileState {
  userprofile: any | null;
  cstpack: any | null;
  loading: boolean;
  error: string | null;
}

export const initialState: CustomerProfileState = {
  userprofile: null,
  cstpack: null,
  loading: false,
  error: null,
};

const CustomerProfileSlice = createSlice({
  name: "CustomerProfile",
  initialState,
  reducers: {
    setCustomerProfileLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setCustomerProfile(state, action: PayloadAction<any>) {
      state.userprofile = action.payload;
      state.cstpack = action.payload?.cstpack || null;
      state.loading = false;
      state.error = null;
    },
    setCustomerProfileError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateCustomerUser(state, action: PayloadAction<any>) {
      if (state.userprofile) {
        state.userprofile = { ...state.userprofile, user: action.payload };
      }
    },
    updateCstPack(state, action: PayloadAction<any>) {
      state.cstpack = action.payload;
      if (state.userprofile) {
        state.userprofile = { ...state.userprofile, cstpack: action.payload };
      }
    },
    clearCustomerProfile(state) {
      state.userprofile = null;
      state.cstpack = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setCustomerProfileLoading,
  setCustomerProfile,
  setCustomerProfileError,
  updateCustomerUser,
  updateCstPack,
  clearCustomerProfile,
} = CustomerProfileSlice.actions;

export default CustomerProfileSlice.reducer;
